import { makeAutoObservable } from 'mobx';

class RevieweeDirectoryState {
  interactiveAgent;
  history;

  cycle;
  reviewerSelectionModalOpen = false;
  selectedReviewee;

  constructor() {
    makeAutoObservable(this, {
      interactiveAgent: false,
      history: false
    });
  }

  receiveProps({cycle, history}) {
    this.cycle = cycle;
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  selectReviewers(reviewee) {
    this.selectedReviewee = reviewee;
    this.reviewerSelectionModalOpen = true;
  }

  closeReviewerSelectionModal() {
    this.reviewerSelectionModalOpen = false;
  }

  onReviewersSelected(reviewee) {
    this.reviewerSelectionModalOpen = false;
    this.interactiveAgent.refresh();
  }

  goToEditParticipants() {
    this.history.push(`/reviews/${this.cycle.id}/edit/participants`);
  }
}

export default RevieweeDirectoryState;
